export const CRYPTO_SECRET_KEY = "InsideRodeo-Crypt-2025";
export const PER_PAGE_LIST = 10;
export const RODEPICK_API_CONST = "rodeo-pick";
export const PROFILE_IMAGE_ASPECT_RATIO = 1;

export const CUSTOM_MESSAGE = {
  SEND_OTP: "6 digit OTP has been sent successfully",
  RESENT_OTP: "OTP Resent successfully.",
};

export const SOCKET_CHANNEL = {
  COUPON: "irCoupon",
  EVENT_GLOW: "eventGlow",
  GROUP_GLOW: "rpGroupEventGlow",
  STATUS_MSG: "irStatusMsg",
  APP_REDIRECT: "appRedirect",
  START_EVENT: "startRpEvent",
  END_ALL_EVENT: "rpEndAllEvent",
  TV_BOARD_IMAGE: "tvBoardEmit",
  GROUP_TV_BOARD_IMAGE: "rpGroupLeaderboardTvImageEmit",
  ADV_PROMOTION: "adsPromotionRodeoPick",
  CONTESTANT_WINNER: "rpContestantWinner",
  PERFORMANCE_START_PICK: "rpStartPerformancePick",
  START_STOP_RP_EVENT: "sartStoptRpEvent",
  RP_PUBLISH_LEADERBOARD: "rpPublishLeaderboard",
  NO_RIDE_RP_EVENT: "noRideRpEvent",
};

export const RODEO_PAGE_NAME: any = {
  LOGIN: "login",
  REGISTRATION: "registration",
  LANDING: "landing",
  PERFORMANCE_LANDING: "performance-landing",
  GROUPS: "groups",
  RODEO_EVENTS: "rodeo-events",
  PAST_RODEO_EVENTS: "past-rodeo-events",
  UPCOMING_EVENTS: "upcoming-events",
  PERFORMANCES: "performances",
  EVENTS: "events",
  RIDERS: "riders",
  PRIZES: "prizes",
  PRIZE_DETAILS: "prize-details",
  MOST_POPULAR_PICKS: "most-popular-picks",
  MY_TEAM: "my-team",
  WINNING_TICKET: "winning-ticket",
  MY_ACCOUNT: "my-account",
  LEADERBOARD: "leaderboard",
  NOT_FOUND_PAGE: "not-found",
  CMS: "cms",
  GROUP_LEADERBOARD: "group-leaderboard",
  TEAM_IMAGE: "team-image",
};

export const MODAL_NAME = {
  COUPON: "coupon",
  DAYSHEET: "daysheet",
  LEAGUE_CODE: "league-code",
  MAKE_PICKS: "make-picks",
  VIEW_PICKS: "view-picks",
  NOTIFY_ME: "notify-me",
  PICKED_TEAM: "picked-team",
  RIDER_SELECTION: "rider-selection",
  SHARE: "share",
  SIGN_IN: "sign-in",
  STATUS: "status",
  UPDATE_DISPLAY_NAME: "update-display-name",
  UPDATE_DOB: "update-dob",
  VIDEO: "video",
  FAN_MAG: "fan-magazine",
  GUEST_SAVE_VOTE: "guest-save-vote",
};
